import React, { useState, useEffect } from 'react';
import PasswordProtection from './components/PasswordProtection';
import TrainMap from './components/TrainMap';
import './App.css';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  // Check if user was previously authenticated (stored in localStorage)
  useEffect(() => {
    const authStatus = localStorage.getItem('trainApp_authenticated');
    if (authStatus === 'true') {
      setIsAuthenticated(true);
    }
  }, []);

  const handleAuthenticated = () => {
    setIsAuthenticated(true);
    localStorage.setItem('trainApp_authenticated', 'true');
  };

  const handleLogout = () => {
    setIsAuthenticated(false);
    localStorage.removeItem('trainApp_authenticated');
  };

  return (
    <div className="App">
      {!isAuthenticated ? (
        <PasswordProtection onAuthenticated={handleAuthenticated} />
      ) : (
        <TrainMap onLogout={handleLogout} />
      )}
    </div>
  );
}

export default App; 